import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { openRemoteModalWrapper } from 'src/components/pages/legacy/components/open-legacy-remote-modal-link';
import { useAuthorization } from 'src/hooks/use-authorization';
import { useUrls } from 'src/hooks/use-urls';

export const useContactInteractionModal = () => {
  const { getEditContactInteractionUrl, getAddContactInteractionUrl } = useUrls();
  const { getFeatureFlag } = useAuthorization();
  const showInlineForm =
    getFeatureFlag('ux-redesign-v2.5') && getFeatureFlag('inline-forms-redesign');
  const history = useHistory();

  const getContactInteractionModalUrl = useCallback(
    (contactInteractionId: number) => {
      return getEditContactInteractionUrl(contactInteractionId);
    },
    [getEditContactInteractionUrl],
  );

  const showContactInteractionModal = useCallback(
    (contactInteractionId: number) => {
      const contactInteractionModalUrl =
        getContactInteractionModalUrl(contactInteractionId);

      if (showInlineForm) {
        history.push(contactInteractionModalUrl);
      } else {
        openRemoteModalWrapper(contactInteractionModalUrl);
      }
    },
    [showInlineForm, getContactInteractionModalUrl, history],
  );

  const showAddContactInteractionModal = useCallback(
    ({ contactId }: { contactId: number }) => {
      const contactInteractionModalUrl = getAddContactInteractionUrl(contactId);

      if (showInlineForm) {
        history.push(contactInteractionModalUrl);
      } else {
        openRemoteModalWrapper(contactInteractionModalUrl);
      }
    },
    [getAddContactInteractionUrl, showInlineForm, history],
  );

  return {
    showContactInteractionModal,
    getContactInteractionModalUrl,
    showAddContactInteractionModal,
  };
};
